import { useConvergeLighting } from "hooks/useConvergeLighting";

export const LightingConverger = () => {
	useConvergeLighting();
	return null;
};
